import { render, staticRenderFns } from "./AdminWorkers.vue?vue&type=template&id=e53b23ae&scoped=true"
import script from "./AdminWorkers.vue?vue&type=script&lang=js"
export * from "./AdminWorkers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53b23ae",
  null
  
)

export default component.exports